export const SELECTED_MODEL_PLACEHOLDER = '{selectedModel}';
export const CURRENT_PRODUCT_PLACEHOLDER = '{currentProduct}';
export const BUTTONS_PANEL_QUANTITY_WIDTH = 160;
export const CART_ICON_WIDTH = 28;
